import {
    Box,
    Tabs,
    Tab
} from "@mui/material";

import DataTable from "../components/DataTable";
import { DataTypeMap } from "../helpers/DataType";

const Data = (props) => {
    const {
        data,
        dataType,
        handleDataTypeChange,
        limit,
        features,
        error
    } = props;

    return (
        <Box sx={{ width: '95%', margin: '5px auto' }}>
            <Tabs
                value={DataTypeMap[dataType]}
                onChange={handleDataTypeChange}
            >
                <Tab id='invoice' label='INVOICES' />
                <Tab id='workOrder' label='WORK ORDERS' />
                <Tab id='quote' label='QUOTES' />
            </Tabs>
            <DataTable
                data={data}
                dataType={dataType}
                limit={limit}
                features={features}
                error={error}
            />
        </Box>
    )
}

export default Data;